import { orgSelectors } from 'ducks/orgs'
import { HardwareSupplierFilterKeyType, SellerIntegrationType } from 'opensolar-common'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export const useSupplierConfig = (
  supplier: HardwareSupplierFilterKeyType | undefined
): SellerIntegrationType | undefined => {
  const availableSuppliers = useSelector(orgSelectors.getEnabledSellerIntegrationsConfig)
  return useMemo(() => {
    if (!supplier) return undefined
    return availableSuppliers.find((item) => item.filterKey === supplier)
  }, [supplier, availableSuppliers])
}
